module.exports = __webpack_public_path__ + "img/EPriestSet64_ua.e766a51e.webp";